import { Button, Col, Layout, Row, Table } from "antd";
import Typography from "antd/es/typography/Typography";
import React, { useEffect, useState } from "react";
import StatCard from "./StatCard";
import EmissionCard from "./EmissionCard";
import RecycleDataTable from "./RecycleDataTable";
import YoYBarChart from "./YoYBarChart";
import ScopePieChart from "./ScopePieChart";
import axios from "axios";
import DetailViewTable from "./DetailViewTable";
import ExcelTable from "./ExcelTable";
import rollbackIcon from "../../assets/icons/rollback.png";
import { useNavigate } from "react-router-dom";
import { CDPReportTableColumns } from "../../constants/Constants";

const { Title } = Typography;

function CarbonReportedDetailedView({report}) {
  // const [report, setReport] = useState({});
  const [recycleData, setRecycleData] = useState(null);
  const [error, setError] = useState(null);
  const email = sessionStorage.getItem("Email");
  const supplierId = sessionStorage.getItem("supplierId");
  const token = sessionStorage.getItem("authToken");
  const currentYear = new Date().getFullYear();
  const role=sessionStorage.getItem("Role")

  const scope1 = report?.scope1 || 0;
  const scope2MB = report?.scope2MarketBased || 0;
  const scope2LB = report?.scope2LocationBased || 0;
  const totalEmission = ((scope1 + scope2MB + scope2LB) / 1000).toFixed(2);
  const previousEmission = report?.emissionsByYear?.[currentYear - 1] || 0;

  const navigate = useNavigate();
  const handleBackClick = () => {
    const basePath = location.pathname.includes("/admin")
    ? "/admin"
    : "/supplier";
    navigate(`${basePath}/dashboard`);
  };


  return (
    <div className="min-h-screen p-6">
      <div className="flex justify-end mb-2">
  <Button
    shape="round"
    icon={<img src={rollbackIcon || "/placeholder.svg"} alt="back" className="w-10 h-5" />}
    size="60px"
    className="w-[100px] h-[30px] bg-[#F8FAFC]"
    style={{ border: "1px solid #A1BAD1" }}
    onClick={handleBackClick}
  >
    Back
  </Button>
</div>
      {/* Header Section */}
      <div className="bg-white p-6 rounded-xl shadow-lg mb-8">
        <Title level={2} className="text-gray-800">
          CDP Carbon Emission Reported
        </Title>
        <p className="text-gray-500">
          Detailed view of your organization's carbon footprint
        </p>
      
      </div>

      {/* Stat Cards */}
      <div className={`grid grid-cols-3 md:grid-cols-2 ${role=="System Admin"?"lg:grid-cols-4":"lg:grid-cols-5"} gap-2 mb-10`}>
        <StatCard Title="Scope 1 Emissions" value={(scope1 / 1000).toFixed(2)} subtext="tonnes CO₂" role={role}/>
        <StatCard Title="Scope 2 MB Emissions" value={(scope2MB / 1000).toFixed(2)} subtext="tonnes CO₂ " role={role} />
        <StatCard Title="Scope 2 LB Emissions" value={(scope2LB / 1000).toFixed(2)} subtext="tonnes CO₂" role={role}/>
        <StatCard Title="YoY Change" value={report?.yoY + "%"} subtext="vs. previous year" role={role}/>
        {role!="System Admin" && (<StatCard Title="Rank" value={(`${report?.supplierRank}/${report?.totalRank}`) || 0} role={role}/>)}
      </div>

      {/* Emission & Recyclable Packaging Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10 ml-8">
        <EmissionCard
          title="Carbon Emissions Avoided"
          value={(report?.totalemissionSaved/1000 || 0).toFixed(2)}
          lastYear={(report?.prevTotalEmissionSaved/1000 || 0).toFixed(2)}
        />
        <EmissionCard
          title="Total Carbon Emission"
          value={totalEmission}
          lastYear={previousEmission}
        />
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10">
        <div className="bg-white shadow-md rounded-lg p-4">
          <Title level={4} className="text-center text-gray-700 mb-3">
            Year-over-Year Emissions Comparison
          </Title>
          <YoYBarChart yeardata={report?.emissionsByYear || {}} />
        </div>

        <div className="bg-white shadow-md rounded-lg p-4">
          <Title level={4} className="text-center text-gray-700 mb-3">
            Carbon Emissions by Scope
          </Title>
          <ScopePieChart report={report} />
        </div>
      </div>
      {role=="System Admin" && <div className="flex justify-end mr-2 mt-2 mb-1">
        <ExcelTable tableData={report?.tableData} title="CDP Carbon Emission Reported" />
      </div>
      }
      {role=="System Admin" && <Row className="mt-2 p-[8px]">
        <Col span={24}>
          <div className="bg-white rounded-lg border-2 border-[#d1d5dc]">
            <Table
              columns={CDPReportTableColumns}
              dataSource={report?.tableData}
              pagination={false}
              className="supplier-CdpReported-table"
              rowClassName={(record, index) =>
                index % 2 === 0 ? "bg-[#F8FAFC]" : "bg-white"
              }
            />
          </div>
        </Col>
      </Row>}
    </div>
  );
}

export default CarbonReportedDetailedView;
